import React from "react"
import styles from "../../../PendingQuestionTable.module.scss"
import { Box, Grid, Typography, useTheme } from "@mui/material"

const Questions = ({ question, isIncorrect }) => {
  const theme = useTheme()
  const boxStyling = { marginTop: "25px", marginBottom: "18px" }

  return (
    <>
      <Box className={styles.question} sx={boxStyling} style={{ maxWidth: 700, minWidth: 500 }}>
        {question?.is_added_manually ? (
          <Typography
            variant="caption3"
            color={theme.palette.secondary.main}
            style={{ opacity: 1 }}
            className={styles.questionHeader}>
            {`${question?.category} | ${question?.food_name} ${
              question?.question_platform ? ` | ${question?.question_platform}` : ""
            } ${question?.added_on ? ` | ${question?.added_on}` : ""}`}
          </Typography>
        ) : (
          <Typography
            variant="caption3"
            color={theme.palette.secondary.main}
            style={{ opacity: 1 }}
            className={styles.questionHeader}>
            {`${question?.food_item_name ? question?.food_item_name : question?.food_name} | ${
              question?.question_platform ?? ""
            }  ${
              question?.category && question?.question_platform ? ` | ${question?.category}` : ""
            }${question?.added_on ? ` | ${question?.added_on}` : ""}`}
            {isIncorrect && (
              <Typography
                variant="caption3"
                style={{ opacity: 1 }}
                color={theme.palette.red.main}
                className={styles.incorrect_analytics}>
                {`${
                  question?.incorrect_percentage
                    ? ` incorrect %: ${question?.incorrect_percentage}%`
                    : ""
                }${question?.incorrect_count ? ` | count: ${question?.incorrect_count}` : ""}`}
              </Typography>
            )}
          </Typography>
        )}
        <Box className={styles.questionTitle}>
          <Typography
            variant="h4"
            style={question?.title?.length > 80 ? { marginTop: 15 } : { margin: 0 }}>
            {question?.title}
          </Typography>
        </Box>
        <Grid container>
          {question?.question_type === "2-images" || question?.question_type === "4-images"
            ? question?.answer?.map((option, index) => (
                <Grid key={option?.id ?? index} item xs={3} gap={2}>
                  <Box
                    className={`${styles.question_bank_image_option} ${
                      option?.is_correct ? styles.optionCorrect : ""
                    }`}>
                    <img
                      src={option?.answer_image_url}
                      alt="option"
                      className={`${styles.optionImage} ${
                        option?.is_correct ? styles.optionCorrectImage : ""
                      }`}
                    />
                    <Typography
                      className={`${styles.optionName} ${styles.question_bank_image_option_name}`}
                      variant="body2Regular">
                      {option?.answer && option?.answer.length > 18
                        ? `${option?.answer.substring(0, 15)}...`
                        : option?.answer || "-"}
                    </Typography>
                  </Box>
                </Grid>
              ))
            : question?.question_type === "matching"
            ? question?.match_pairs?.map((pair, index) => (
                <Grid key={index} item xs={6} gap={2}>
                  <Box key={index} className={`${styles.question_bank_option}`}>
                    <Box className={styles.optionNumber}>
                      <Typography variant="tag1">
                        {(index + 10).toString(36).toUpperCase()}
                      </Typography>
                    </Box>
                    <Box className="d-flex flex-column gap-1">
                      <Typography className={styles.optionName} variant="body2Regular">
                        {pair?.left_text}
                      </Typography>
                      <Typography
                        className={styles.optionName}
                        variant="body2Regular"
                        color={theme.palette.success.main}>
                        {pair?.right_text}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))
            : question?.answer?.map((option, index) => (
                <Grid key={option.id} item xs={6} gap={2}>
                  <Box
                    className={`${styles.question_bank_option} ${
                      option?.is_correct ? styles.optionCorrect : ""
                    }`}>
                    <div className={styles.optionNumber}>
                      <Typography variant="tag1">
                        {(index + 10).toString(36).toUpperCase()}
                      </Typography>
                    </div>
                    <Typography className={styles.optionName} variant="body2Regular">
                      {option?.answer}
                    </Typography>
                  </Box>
                </Grid>
              ))}
        </Grid>
      </Box>
    </>
  )
}

export default Questions
